import { render, staticRenderFns } from "./User_Dashboard.vue?vue&type=template&id=4485e634&scoped=true&"
import script from "./User_Dashboard.vue?vue&type=script&lang=js&"
export * from "./User_Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./User_Dashboard.vue?vue&type=style&index=0&id=4485e634&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4485e634",
  null
  
)

export default component.exports